import React from 'react';
import ReactDOM from 'react-dom/client';
import './App.css';
// 진입 주소의 ui 파라미터(A/B)를 라우팅 전에 기록한다
import 'utils/uiVariant';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
